<template>
  <PersonaResidenceInteractiveForm
    :display-steps="displaySteps"
    :busy="busy"
    @submit="submit"
  />
</template>
<script>
import { mapActions } from 'vuex'
import PersonaResidenceInteractiveForm from '@/components/forms/persona/interactive/PersonaResidenceInteractiveForm.vue'
export default {
  name: 'PersonaResidenceInteractiveFormContainer',
  components: {
    PersonaResidenceInteractiveForm,
  },
  props: {
    displaySteps: { type: Array, default: () => [] },
  },
  emits: ['personaResidenceSubmitted', 'submit'],
  data() {
    return {
      busy: false,
    }
  },
  methods: {
    ...mapActions({
      setPersona: 'user/persona/setPersona',
    }),
    async submit(personaResidence) {
      this.busy = true
      await this.setPersona({
        persona: {
          residence: {
            ...personaResidence,
            zip_code: personaResidence.zip_code.replace(/\D/g, ''),
          },
        },
      })
      this.busy = false
      this.$emit('personaResidenceSubmitted')
      this.$emit('submit')
    },
  },
}
</script>
<style lang="scss"></style>
